import CONFIG from 'jsx/constants/config';

export const getSignUpDestination = (inAppUrl: string): string => {
  const { quizServiceUrl } = CONFIG;

  return CONFIG.isAgencyApp && CONFIG.isAgencyRebrandEnabled && quizServiceUrl
    ? quizServiceUrl
    : inAppUrl;
};
